// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Karussell_sliderContainer__85Iaw","slide":"Karussell_slide__36PTn","active":"Karussell_active__ENQ4l"};